import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import {
    FilterHeading,
    FilterHeader,
} from 'src/common/components/filter/Filters.styled.jsx';

export const SearchHeading = styled(FilterHeading)`
    font-family: AvenirNextWorld Regular;
    ${media.mobileDevice`
        font-size: 24px;
        font-family: AvenirNextWorld Demi;
    `}
`;

export const SearchHeader = styled(FilterHeader)`
    margin-bottom: 0px;
    ${media.mobileDevice`
    margin-bottom: ${({ mobileMarginBottom }) =>
        mobileMarginBottom ? mobileMarginBottom : '0'}
    `}
`;

export const SurgeryDateView = styled.div`
    display: inline-flex;
    width: 100%;
    align-items: center;
`;

export const EmptyBox = styled.div`
    margin: 12%;
    ${media.smalDevice`
        margin: 30%;
    `}
    ${media.mobileDevice`
        margin: ${({ mobileMargin }) => (mobileMargin ? mobileMargin : '30%')} ;
    `}
`;
